export default {
    confirmation: 'Your innovation project has been successfully proposed.'
}
